import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import { FC } from 'react'

type Props = {
    discountPercent?: number
}

export const DiscountBadge: FC<Props> = ({ discountPercent }) => (
    <Stack
        sx={{
            position: 'absolute',
            display: 'inline-block',
            top: '1.5rem',
            right: '2.5rem',
            maxWidth: '1rem',
            zIndex: 1,
            transform: 'rotatez(45deg)',

            '&:after': {
                position: 'absolute',
                top: '-0.3rem',
                right: '-7rem',
                content: '""',
                height: '2rem',
                width: '15rem',

                backgroundColor: '#006CFD',
                zIndex: -1,
            },
        }}>
        <Typography variant="h6" color="#FFFFFF">
            -{discountPercent}%
        </Typography>
    </Stack>
)
